// export type ViewMode = ViewModes.card | Viewmodes.table
enum ViewMode {
  Card = 'card',
  Table = 'table',
}

export default ViewMode
